const config = {
  google: {
    API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    SECRET: process.env.REACT_APP_GOOGLE_SECRET || "",
  },
  facebook: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  },
  api: {
    // Use environment variable or default to localhost
    // IMPORTANT: If REACT_APP_API_URL is not set, use the backend server URL
    API_URL: (() => {
      const envUrl = process.env.REACT_APP_API_URL;
      if (envUrl) {
        return envUrl;
      }
      // Default to backend server
      return "http://localhost:5001/api";
    })(),
  }
};

// Debug: Log the API URL being used
console.log("🔧 Config API_URL:", config.api.API_URL);

module.exports = config;
